import {config} from "@/config/config"
export default [/*{
    name: 'homepage',
    path: '/',
    component: () => import('./containers/home-page/index'),
}, {
    name: 'plans',
    path: '/plans-pricing',
    component: () => import('./containers/Pricing'),
}, {
    name: 'methodology',
    path: '/methodology',
    component: () => import('./containers/Methodology'),
}, {
    name: 'blog',
    path: '/blog/:category?',
    component: () => import('./containers/Blog'),
}, {
    name: 'blog_full',
    path: '/blog-view/:id',
    component: () => import('./containers/BlogFull'),
}, */ {
    name: 'tos',
    path: '/tos',
    component: () => import('./containers/TOS'),
}, {
    name: 'privacy',
    path: '/privacy-policy',
    component: () => import('./containers/Privacy'),
},
{
    name: 'plans',
    path: '/plans-pricing',
    beforeEnter: function () {
        let planUrl = config('HOMEPAGE') + 'plans-pricing';
        window.location.href = planUrl;
    }
}
];


